module.exports = __webpack_public_path__ + "static/media/logo1.bd97886b.png";